// external libraries
import anime from 'animejs'

export default {
	functional: true,
	render: (createElement, context) => {
		// internal props
		const duration = context.props.duration || 500
		const delay = context.props.delay || 0
		const data = {
			props: {
				mode: 'out-in',
				css: false,
				duration: {
					type: [String, Number],
					default: 500
				},
				delay: {
					type: [String, Number],
					default: 0
				}
			},
			on: {
				enter(el) {
					anime.timeline()
					.add({
						targets: el,
						opacity: [0, 1],
						scale: [1.5, 1],
						easing: 'easeOutExpo',
						duration: duration,
						delay: delay
					})
				},
				leave(el, done) {
					anime.timeline()
					.add({
						targets: el,
						opacity: [1, 0],
						scale: [1, 1.5],
						easing: 'easeOutExpo',
						duration: duration
					})
					.complete = done
				}
			}
		}
		return createElement('transition-group', data, context.children)
	},
	methods: {
		enter() {},
		leave() {}
	}
}
